// src/admin/AdminEntry.js
import { Navigate } from "react-router-dom";

export default function AdminEntry() {
  const role = localStorage.getItem("role");

  return role === "admin"
    ? <Navigate to="/admin/dashboard" />
    : <Navigate to="/admin/login" />;
}